<script setup>
import { shallowRef, watch } from 'vue';
import UiPerson from '@/components/ui/UiPerson.vue';
import UiTableCard from '@/components/ui/UiTableCard.vue';
import { apiRequest } from '@/api/http';
import { useListResource } from '@/composables/useListResource';
import { useSessionGuard } from '@/composables/useSessionGuard';
import { titleCase } from '@/utils/format';

// Faculty teaching each grade. High school by default; the elementary
// page reuses this view with grades 1–6.
const props = defineProps({
  grades: { type: Array, default: () => [7, 8, 9, 10, 11, 12] },
});

useSessionGuard();

const tabs = props.grades.map((g) => ({ id: g, name: `Grade ${g}` }));
const grade = shallowRef(props.grades[0]);
const headers = [
  { title: 'Faculty', key: 'name' },
  { title: 'Mobile number', key: 'mobile_no', sortable: false },
];

const { items, loading, error, load } = useListResource(async () => {
  const rows = await apiRequest('get', `/subjects/getFacultyList/${grade.value}`);
  return (rows || []).map((r) => ({ ...r, name: titleCase(r.name) }));
});
watch(grade, load, { immediate: true });
</script>

<template>
  <UiTableCard
    v-model:tab="grade"
    title="Faculty list"
    description="Teachers handling classes in each grade level."
    :tabs="tabs"
    :headers="headers"
    :items="items"
    :loading="loading"
    :error="error"
    search-placeholder="Search faculty"
    empty-text="No faculty assigned to this grade yet."
  >
    <template #[`item.name`]="{ item }">
      <UiPerson :name="item.name" />
    </template>
    <template #[`item.mobile_no`]="{ item }">
      <span class="text-medium-emphasis">{{ item.mobile_no || '—' }}</span>
    </template>
  </UiTableCard>
</template>
